import { InMemoryCacheConfig, TypePolicies } from '@apollo/client';
import cacheKeyFields from './cacheKeyFields';
import cacheMergePolicies from './cacheMergePolicies';
import cacheQueryPolicies from './cacheQueryPolicies';
import possibleTypes from './possibleTypes.json';
import { HubspotInMemoryCache } from 'hubspot-apollo-cache';

function getTypePolicies(): InMemoryCacheConfig['typePolicies'] {
  return [
    ...Object.keys(cacheMergePolicies),
    ...Object.keys(cacheKeyFields),
    ...Object.keys(cacheQueryPolicies),
  ].reduce((typePolicies: TypePolicies, typeName: string) => {
    return {
      /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
      ...typePolicies,
      [typeName]: {
        ...cacheMergePolicies[typeName],
        ...cacheKeyFields[typeName],
        ...cacheQueryPolicies[typeName],
      },
    };
  }, {});
}

export const createCache = () =>
  new HubspotInMemoryCache({
    location: 'hubspot-apollo-client',
    canonizeResults: true,
    possibleTypes,
    typePolicies: getTypePolicies(),
  });
